module.exports = __webpack_public_path__ + "img/ic_splash_logo.13a62005.png";